// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"Carousel_carouselItem__1HfWC","carouselItem-img":"Carousel_carouselItem-img__1BBB6"};